import React, { useEffect } from 'react';
import { FinalCTA } from '../components/home/FinalCTA';
import { IncludedList } from '../components/page/IncludedList';
import { PageHero } from '../components/page/PageHero';
import { WhyLawyerLed } from '../components/page/WhyLawyerLed';
import { servicePages } from '../data/servicePages';
interface ServiceDetailProps {
  serviceKey: keyof typeof servicePages;
}
export function ServiceDetail({
  serviceKey
}: ServiceDetailProps) {
  const service = servicePages[serviceKey];
  useEffect(() => {
    document.title = service.title;
    window.scrollTo(0, 0);
  }, [service.title]);
  return <main data-id="element-682" data-mp="17sj2kkx100t7">
      <PageHero eyebrow={service.eyebrow} title={service.heroTitle} intro={service.intro} primaryLabel="Get a free quote" primaryAction="quote" data-id="element-683" data-mp="17s992ncrvbir" />
      <IncludedList eyebrow="how we help" heading={service.sectionHeading} intro={service.sectionIntro} items={service.items} data-id="element-684" data-mp="3skkw9286xguq" />
      <WhyLawyerLed data-id="element-685" data-mp="18gzya55vo1gi" />
      <FinalCTA data-id="element-686" data-mp="18gq9gkwkk0ce" />
    </main>;
}